import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function Home() {
  const [activeCategory, setActiveCategory] = useState<string>('all');

  const featuredArticles = articles.filter((a) => a.isFeatured).slice(0, 4);
  const hotArticles = articles.filter((a) => a.isHot && !a.isFeatured).slice(0, 6);
  const filteredArticles = activeCategory === 'all'
    ? articles
    : articles.filter((a) => a.category === activeCategory);
  const latestArticles = articles.slice(0, 8);

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '17吃瓜',
    url: 'https://17chigua.com',
    description: '17吃瓜是您获取最新娱乐八卦、明星爆料、热点事件的首选平台。海量独家内容每日更新。',
    email: 'contact@17chigua.com',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '光华路88号',
      addressLocality: '北京',
      addressRegion: '朝阳区',
      addressCountry: 'CN',
    },
  };

  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '17吃瓜',
    url: 'https://17chigua.com',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://17chigua.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <SEOHead
        title="17吃瓜 - 最新热点娱乐爆料聚合平台"
        description="17吃瓜是您获取最新娱乐八卦、明星爆料、热点事件的首选平台。海量独家内容每日更新，带您第一时间围观最劲爆的吃瓜现场，不错过任何热门话题与娱乐资讯。"
        keywords="17吃瓜,吃瓜热点,娱乐爆料,明星八卦,最新吃瓜事件,热门娱乐资讯,独家爆料平台,吃瓜现场直击"
        canonicalUrl="https://17chigua.com"
        schema={[orgSchema, webSiteSchema]}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20moody%20entertainment%20news%20backdrop%20with%20abstract%20neon%20red%20and%20warm%20orange%20glowing%20lights%2C%20dramatic%20stage%20atmosphere%2C%20modern%20media%20studio%20vibe%2C%20cinematic%20lighting%20with%20lens%20flares%2C%20editorial%20newsroom%20energy%2C%20dark%20gradient%20background&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
              alt="17吃瓜 - 娱乐爆料平台"
              className="absolute inset-0 w-full h-full object-cover"
              title="17吃瓜 - 最新热点娱乐爆料聚合平台"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/70"></div>
            <div className="relative z-10 w-full max-w-4xl mx-auto px-4 text-center">
              <div className="inline-flex items-center gap-2 bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 rounded-full px-4 py-1.5 mb-6">
                <span className="w-2 h-2 rounded-full bg-primary-400 animate-pulse"></span>
                <span className="text-sm text-background-50/90 font-medium">实时爆料 · 每日更新</span>
              </div>
              <h1 className="text-4xl md:text-6xl font-bold text-background-50 leading-tight tracking-tight">
                不放过任何一个<span className="text-primary-400">瓜</span>
              </h1>
              <p className="mt-5 text-lg md:text-xl text-background-50/80 max-w-2xl mx-auto leading-relaxed">
                海量独家内容每日更新，带您第一时间围观最劲爆的吃瓜现场
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
                <Link
                  to="/category/mingxing-bagua"
                  className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full transition-all text-base whitespace-nowrap cursor-pointer"
                >
                  立即吃瓜
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
                <Link
                  to="/about"
                  className="px-8 py-3 bg-background-50/10 hover:bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 font-semibold rounded-full transition-all text-base whitespace-nowrap cursor-pointer"
                >
                  了解更多
                </Link>
              </div>
            </div>
          </section>

          {/* Category Tabs */}
          <section className="max-w-7xl mx-auto px-4 md:px-6 -mt-8 relative z-20">
            <div className="bg-background-50 rounded-xl p-1.5 flex flex-wrap items-center gap-1 border border-background-200/70">
              <button
                onClick={() => setActiveCategory('all')}
                className={`px-5 py-2.5 text-sm font-medium rounded-lg transition-all whitespace-nowrap cursor-pointer ${
                  activeCategory === 'all'
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:bg-background-100'
                }`}
              >
                <i className="ri-home-4-line mr-1.5"></i>
                全部
              </button>
              {categories.map((cat) => (
                <button
                  key={cat.slug}
                  onClick={() => setActiveCategory(cat.slug)}
                  className={`px-5 py-2.5 text-sm font-medium rounded-lg transition-all whitespace-nowrap cursor-pointer ${
                    activeCategory === cat.slug
                      ? 'bg-secondary-500 text-background-50'
                      : 'text-foreground-600 hover:bg-background-100'
                  }`}
                >
                  <i className={`${cat.icon} mr-1.5`}></i>
                  {cat.name}
                </button>
              ))}
            </div>
          </section>

          {/* Featured Articles */}
          <section className="max-w-7xl mx-auto px-4 md:px-6 mt-12">
            <div className="flex items-center justify-between mb-7">
              <div>
                <h2 className="text-2xl font-bold text-foreground-950">头条爆料</h2>
                <p className="text-sm text-foreground-500 mt-1">最新最热的吃瓜资讯，一手掌握</p>
              </div>
              <Link
                to={activeCategory === 'all' ? '/category/mingxing-bagua' : `/category/${activeCategory}`}
                className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                查看全部
                <i className="ri-arrow-right-s-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {featuredArticles.map((article) => (
                <ArticleCard key={article.id} article={article} variant="featured" />
              ))}
            </div>
          </section>

          {/* Content Grid: Articles + Sidebar */}
          <section className="max-w-7xl mx-auto px-4 md:px-6 mt-14">
            <div className="flex flex-col lg:flex-row gap-8">
              {/* Main Content */}
              <div className="flex-1">
                <div className="flex items-center justify-between mb-7">
                  <h2 className="text-2xl font-bold text-foreground-950">最新瓜报</h2>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  {latestArticles.map((article) => (
                    <ArticleCard key={article.id} article={article} />
                  ))}
                </div>
                <div className="flex justify-center mt-8">
                  <button className="px-8 py-3 border border-background-300/60 text-foreground-700 hover:bg-background-100 font-medium rounded-full transition-all text-sm whitespace-nowrap cursor-pointer">
                    加载更多爆料
                    <i className="ri-arrow-down-line ml-2"></i>
                  </button>
                </div>
              </div>

              {/* Sidebar */}
              <aside className="w-full lg:w-80 flex-shrink-0">
                <div className="sticky top-24 space-y-6">
                  {/* Hot Articles */}
                  <div className="bg-background-50 border border-background-200/70 rounded-lg p-5">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-6 h-6 rounded-full bg-primary-500 flex items-center justify-center">
                        <i className="ri-fire-line text-xs text-background-50"></i>
                      </div>
                      <h3 className="font-semibold text-foreground-950">热点排行</h3>
                    </div>
                    <div className="space-y-1">
                      {hotArticles.map((article, idx) => (
                        <ArticleCard key={article.id} article={article} variant="compact" />
                      ))}
                    </div>
                  </div>

                  {/* Newsletter */}
                  <div className="bg-gradient-to-br from-secondary-100 to-accent-100 rounded-lg p-5">
                    <div className="w-11 h-11 rounded-full bg-accent-500 flex items-center justify-center mb-4">
                      <i className="ri-notification-3-line text-lg text-background-50"></i>
                    </div>
                    <h3 className="font-semibold text-foreground-950 mb-2">瓜田速递</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                      订阅我们的推送，不错过任何一个重磅爆料！
                    </p>
                    <div className="flex gap-2">
                      <input
                        type="email"
                        placeholder="输入邮箱地址"
                        className="flex-1 px-3 py-2 text-sm bg-background-50 border border-background-300/60 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
                      />
                      <button className="px-4 py-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer">
                        订阅
                      </button>
                    </div>
                  </div>
                </div>
              </aside>
            </div>
          </section>

          {/* Category Quick Links */}
          <section className="max-w-7xl mx-auto px-4 md:px-6 mt-14 mb-14">
            <h2 className="text-2xl font-bold text-foreground-950 mb-7">热门分类</h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group flex flex-col items-center p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-accent-300 hover:bg-accent-50/50 transition-all cursor-pointer"
                >
                  <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mb-3 group-hover:bg-accent-200 transition-colors">
                    <i className={`${cat.icon} text-xl text-accent-600`}></i>
                  </div>
                  <span className="text-sm font-semibold text-foreground-900">{cat.name}</span>
                  <span className="text-xs text-foreground-500 mt-1">{cat.count}篇爆料</span>
                </Link>
              ))}
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}